import { Flex } from "antd"
import React from "react"
import { Outlet } from "react-router-dom"

import { FixedContainer } from "../../../components/FixedContainer.tsx"
import { ContractsHeader } from "./ContractsHeader.tsx"
import ContractsSidebar from "./ContractsSidebar/ContractsSidebar.tsx"

export function ContractsLayout() {
  return (
    <FixedContainer>
      <ContractsHeader />

      <Flex flex={1} gap={"middle"} className={"overflow-hidden"}>
        <ContractsSidebar />
        <Outlet />
      </Flex>
    </FixedContainer>
  )
}
